import { useEffect } from 'react';
import type { FC } from 'react';

import { measuredLocations, MEASURE_KEY } from './constants.ts';
import { useConnectAppsState } from './useConnectAppsState.ts';

type ConnectAppLoadEndProps = {
	location: string;
	items: string[];
};

export const ConnectAppLoadEnd: FC<ConnectAppLoadEndProps> = ({ location, items }) => {
	// eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
	const [, connectAppsActions] = useConnectAppsState();

	useEffect(() => {
		if (location && measuredLocations.indexOf(location) !== -1) {
			const filteredItems = items.filter((item) => item.indexOf(MEASURE_KEY) !== -1);
			connectAppsActions.updateConnectApps({
				location,
				items: filteredItems,
				isLoaded: true,
			});
		}
	}, [location, items, connectAppsActions]);

	return null;
};
